var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-answer",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }